import { useEffect, useState } from 'react';

/**
 * Debounces a value. Used by search inputs so each keystroke does not become a
 * query key change (and therefore a request).
 */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
